/**
 * Settlement and charge display helpers (TMMPDM-0037). Formatting and links only — no value is
 * computed from two server fields (REFERENCE-console-composition-rule).
 */
import type { PayoutStatus, ResellerChargeKind, ResellerChargeStatus } from '@/api/tmm/types';

/** A reseller charge's status label: the English fallback (the tone is the registry's, ResellerChargeChip). */
export const CHARGE_STATUS_FALLBACK: Record<ResellerChargeStatus, string> = {
  PENDING: 'Pending',
  REQUESTED: 'Processing',
  // TMMPDM-0044: "Paid" is the payout status only; a collected charge says so.
  SUCCEEDED: 'Charge collected',
  FAILED: 'Failed',
  REQUIRES_ACTION: 'Needs action',
};

export const CHARGE_KIND_FALLBACK: Record<ResellerChargeKind, string> = {
  MINIMUM_SHORTFALL: 'Minimum shortfall',
  STATEMENT_DEFICIT: 'Statement deficit',
};

/** The deep link to one charge on the reseller's Billing tab (relative to the reseller page). */
export function chargeHref(chargeId: number): string {
  return `?tab=billing&charge=${encodeURIComponent(String(chargeId))}`;
}

/** A settlement's outcome in words (STATE-001), by its `payoutStatus` alone. */
export const SETTLEMENT_OUTCOME_FALLBACK: Record<PayoutStatus, string> = {
  RETAINED: 'Retained',
  PAID: 'Paid {{date}}',
  PENDING: 'To pay',
  CARRIED: 'Carried (under minimum)',
  CHARGED: 'Charged to card',
};
